import React from "react";
import Breadcrumb_comp from "../common_components/breadcrumb-comp/Breadcrumb_comp";
import "./Privacy_Policy.css";
import Common_Banner_2 from "../common_components/common_banner_2/Common_Banner_2";

const Privacy_Policy = () => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "PRIVACY POLICY", link: "", isActive: true },
  ];

  return (
    <section className="Privacy_Policy">
      <Common_Banner_2
        imgSrc={"/assets/images/privacy_policy/banner.png"}
        title_text="Privacy Policy"
        breadcrumbs={breadcrumbs}
      />

      <div className="container">
        <div className="info_main_div">
          <p className="descn_text">
            At Tech Interiors and Designers, we respect your privacy and are
            committed to protecting the personal information you share with us.
            This Privacy Policy explains how we collect, use, and safeguard your
            information when you visit our website or interact with our
            services.
          </p>

          <p className="title_text">1. Information We Collect</p>
          <p className="descn_text">
            We may collect the following types of information:
          </p>
          <ul className="descn_text">
            <li>
              Personal Information: Name, email, phone number, and address when
              you fill out a contact form or request a consultation.
            </li>
            <li>
              Non-Personal Information: Browser type, device details, IP
              address, and website usage data collected automatically for
              analytics.
            </li>
          </ul>

        

          <p className="title_text">2. How We Use Your Information</p>
          <p className="descn_text">We use the collected information to:</p>
          <ul className="descn_text">
            <li>
              Respond to inquiries and provide interior design consultations.
            </li>
            <li>Share quotations, designs, or service-related updates.</li>
            <li>Improve our website, services, and customer experience.</li>
            <li>
              Send promotional or marketing communication (only with your
              consent).
            </li>
          </ul>

          <p className="title_text">3. Sharing of Information</p>
          <p className="descn_text">
            We do not sell, rent, or trade your personal information to third
            parties. We may share information only with:
          </p>
          <ul className="descn_text">
            <li>Service providers assisting in project execution.</li>
            <li>Legal authorities if required by law.</li>
          </ul>

          <p className="title_text">4. Cookies & Tracking</p>
          <p className="descn_text">
            Our website may use cookies or similar technologies to enhance user
            experience, analyze traffic, and improve functionality. You can
            disable cookies through your browser settings, though some features
            may not function properly
          </p>

          <p className="title_text">5. Data Security</p>
          <p className="descn_text">
            We implement reasonable security measures to protect your personal
            data. However, no online platform is 100% secure, and we cannot
            guarantee absolute security.
          </p>

          <p className="title_text">6. Your Rights</p>
          <p className="descn_text">You have the right to:</p>
          <ul className="descn_text">
            <li> Access the personal data we hold about you.</li>
            <li>Request corrections or updates to your information.</li>
            <li> Opt out of marketing communications at any time.</li>
          </ul>

          <p className="title_text">7. Third-Party Links</p>
          <p className="descn_text">
            Our website may contain links to third-party sites. We are not
            responsible for the privacy practices or content of such websites
          </p>

          <p className="title_text">8. Contact Us</p>
          <p className="descn_text">
            If you have any questions about this Privacy Policy or how your data
            is handled, please contact us at:
          </p>
          <ul className="descn_text">
            <li> Email: techinteriorsanddesigners@gmail.com</li>
            <li>Phone: 9767297324 / 9822502659</li>
            <li> Address: Pune, Maharashtra</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Privacy_Policy;
